import { useEffect, useState } from 'react';
import { App } from 'antd';
import { useNavigate } from 'react-router';
import WorkSpaceService from 'services/master/workspace';

const services = new WorkSpaceService();

const useComponent = ({ w_id }) => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [workspace, setWorkspace] = useState(null);
  const [history, setHistory] = useState([]);
  const [demoCredentials, setDemoCredentials] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sampleModalOpen, setSampleModalOpen] = useState(false);
  const [sampleSubmitting, setSampleSubmitting] = useState(false);

  const load = async () => {
    if (!w_id) return;
    setLoading(true);
    try {
      const result = await services.detail({ w_id });
      setWorkspace(result?.workspace || null);
      setHistory(Array.isArray(result?.history) ? result.history : []);
      setDemoCredentials(result?.demo_credentials || null);
    } catch (e) {
      message.error(e?.message || 'Lấy thông tin thất bại');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [w_id]);

  const isInvalidateShop = (record) => {
    const tier = record?.subscription?.tier || 'mien_phi';
    const expiryOn = record?.subscription?.expiry_on;
    if (tier !== 'mien_phi' || !expiryOn) return false;
    const expiryTime = new Date(expiryOn).getTime();
    if (Number.isNaN(expiryTime)) return false;
    return expiryTime < Date.now();
  };

  const packageStatusLabel = (status) => {
    const map = {
      payment_pending: 'Chờ thanh toán',
      payment_confirmed: 'Chờ duyệt',
      approved: 'Đã duyệt',
    };
    return map[status] || status;
  };

  const packageStatusColor = (status) => {
    const map = {
      payment_pending: 'default',
      payment_confirmed: 'orange',
      approved: 'green',
    };
    return map[status] || 'default';
  };

  const goBack = () => navigate('/workspace');

  const openSampleModal = () => setSampleModalOpen(true);
  const closeSampleModal = () => {
    if (!sampleSubmitting) {
      setSampleModalOpen(false);
    }
  };

  const copyText = async (text, label = 'Nội dung') => {
    try {
      await navigator.clipboard.writeText(String(text || ''));
      message.success(`Đã copy ${label}`);
    } catch {
      message.error('Copy thất bại');
    }
  };

  const copyAllDemoCredentials = async () => {
    if (!demoCredentials && !workspace) return;
    const lines = [
      `Shop: ${workspace?.web_site?.title || ''}`,
      `URL: https://${workspace?.web_site?.url || ''}.sipro.store`,
      `Login ID: ${demoCredentials?.login_id || ''}`,
      `Mật khẩu: ${demoCredentials?.password || ''}`,
    ];
    await copyText(lines.join('\n'), 'thông tin đăng nhập');
  };

  const createSampleData = async ({ shop_description_prompt, reset_homepage }) => {
    if (!w_id) return;
    setSampleSubmitting(true);
    try {
      const result = await services.createSampleData({
        w_id,
        shop_description_prompt,
        reset_homepage,
      });
      message.success(
        `Đã tạo dữ liệu mẫu: ${result?.products_created || 0} sản phẩm, ${result?.tags_created || 0} tag, ${result?.categories_created || 0} category, ${result?.collections_created || 0} collection`
      );
      setSampleModalOpen(false);
      await load();
    } catch (e) {
      message.error(e?.message || 'Tạo dữ liệu mẫu thất bại');
    } finally {
      setSampleSubmitting(false);
    }
  };


  return {
    workspace,
    history,
    demoCredentials,
    loading,
    isInvalidateShop,
    packageStatusLabel,
    packageStatusColor,
    goBack,
    copyText,
    copyAllDemoCredentials,
    sampleModalOpen,
    sampleSubmitting,
    openSampleModal,
    closeSampleModal,
    createSampleData,
  };
};

export default useComponent;
